import { GET_QUEUES } from './mutation-types'

export default {
  [GET_QUEUES]: (state, queues) => {
    state.queues = queues
  },
}
